import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-key'

// Log apenas em desenvolvimento se não tiver variáveis
if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY) {
  console.warn('Variáveis de ambiente do Supabase não configuradas. Configure VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY no .env')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Tipos para o banco de dados
export interface Emenda {
  id: string
  titulo: string
  resumo?: string
  descricao_completa?: string
  valor_emenda?: number
  origem_verba?: string
  area_investimento?: string
  municipio_beneficiado?: string
  estado?: string
  data_publicacao?: string
  status: 'ativo' | 'inativo' | 'rascunho'
  imagem_capa?: string
  created_at: string
  updated_at: string
}

export interface EmendaDocumento {
  id: string
  emenda_id: string
  nome_documento: string
  arquivo_url: string
  tipo_documento: string
  created_at: string
}

export interface EmendaImagem {
  id: string
  emenda_id: string
  imagem_url: string
  descricao?: string
  created_at: string
}

export interface EmendaCompleta extends Emenda {
  documentos: EmendaDocumento[]
  imagens: EmendaImagem[]
}

export interface User {
  id: string
  email: string
  user_metadata: {
    role?: string
    name?: string
  }
}

// Funções auxiliares
export const verificarAdmin = async (): Promise<boolean> => {
  // Como estamos usando autenticação personalizada, 
  // a verificação é feita no contexto de autenticação
  const userStr = localStorage.getItem('admin_user')
  if (!userStr) return false
  
  try {
    const user = JSON.parse(userStr)
    return user.role === 'admin'
  } catch {
    return false
  }
}

export const formatarMoeda = (valor: number | null | undefined): string => {
  if (!valor) return 'R$ 0,00'
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor)
}

export const formatarData = (data: string | null | undefined): string => {
  if (!data) return '-'
  return new Intl.DateTimeFormat('pt-BR').format(new Date(data))
}
